import { render, staticRenderFns } from "./PageAccount.vue?vue&type=template&id=10400ac8&"
import script from "./PageAccount.vue?vue&type=script&lang=js&"
export * from "./PageAccount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/digital-seaside/sst-admin-panel/webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('10400ac8')) {
      api.createRecord('10400ac8', component.options)
    } else {
      api.reload('10400ac8', component.options)
    }
    module.hot.accept("./PageAccount.vue?vue&type=template&id=10400ac8&", function () {
      api.rerender('10400ac8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/account/PageAccount.vue"
export default component.exports